import * as React from 'react';
import { FireScreenEventOnMount } from '@atlassian/help-center-common-util/analytics/fire-screen-event';
import { RecentFormContainer } from './styled';
import { RecentForms } from 'view/help-center/recent-forms';
import { FeaturedAndSortedPortalsCardList } from '../../featured-and-sorted-portals-card-list';
import type { RequestTypeSuggestion } from 'state/persisted/request-type-suggestion';
import type { fetchFeaturedAndSortedPortalsModel } from 'state/actions/featured-and-sorted-portals';
import type { SortBy } from 'rest/featured-and-sorted-portals/types';
import type { PortalSummary } from 'rest/featured-and-sorted-portals';

export interface Props {
    defaultViewPortals: PortalSummary[];
    expandedViewPortals: PortalSummary[];
    sortBy: SortBy;
    total: number;
    requestTypeSuggestions: RequestTypeSuggestion[];
    isExpandedViewLoading: boolean;
    featuredPortalsCount: number;
    isCustomizing: boolean;
    fetchFeaturedAndSortedPortals: typeof fetchFeaturedAndSortedPortalsModel;
}

export default class FeaturedAndSortedPortals extends React.Component<Props> {
    render() {
        const {
            defaultViewPortals,
            expandedViewPortals,
            sortBy,
            total,
            requestTypeSuggestions,
            isExpandedViewLoading,
            featuredPortalsCount,
            isCustomizing,
            fetchFeaturedAndSortedPortals,
        } = this.props;
        const showRecentForms = requestTypeSuggestions.length > 0;

        return (
            <>
                <FireScreenEventOnMount />
                <FeaturedAndSortedPortalsCardList
                    defaultViewPortals={defaultViewPortals}
                    expandedViewPortals={expandedViewPortals}
                    sortBy={sortBy}
                    total={total}
                    fetchFeaturedAndSortedPortals={fetchFeaturedAndSortedPortals}
                    isExpandedViewLoading={isExpandedViewLoading}
                    featuredPortalsCount={featuredPortalsCount}
                    isSidebarOpen={isCustomizing}
                />
                {showRecentForms && (
                    <RecentFormContainer>
                        <RecentForms suggestedRequestTypes={requestTypeSuggestions} />
                    </RecentFormContainer>
                )}
            </>
        );
    }
}
